<template>
  <v-card flat>
    <v-tabs v-model="addType">
      <v-tab> <v-icon class="mr-2">web</v-icon> WEBPAGE </v-tab>
      <v-tab> <v-icon class="mr-2">cloud_upload</v-icon> FILE </v-tab>
      <v-tab> <v-icon class="mr-2">photo</v-icon>IMAGE </v-tab>
      <v-tab> <v-icon class="mr-2">insert_drive_file</v-icon>PAGE </v-tab>
    </v-tabs>
    <v-layout column class="pa-4">
      <v-col v-if="addType == 0">
        <v-text-field
          loading
          disabled
          messages="TESTING"
          label="Webpage URL!"
          placeholder="https://website.com"
        ></v-text-field>
      </v-col>
      <v-col v-if="addType == 1">
        <v-file-input show-size label="Select File"></v-file-input>
      </v-col>
      <v-col v-if="addType == 2">
        <v-file-input
          accept="image/png, image/jpeg, image/bmp"
          prepend-icon="photo"
          show-size
          label="Select Image"
        ></v-file-input>
      </v-col>
      <v-col>
        <v-btn color="primary">Add Resource</v-btn>
      </v-col>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      addType: 0
    };
  }
};
</script>
